import { type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Stack, Text } from '@mantine/core'
import { useTranslation } from '@front/model'
import { Page, TButton } from '@components'

const CLI_DOCS_URL = 'https://docs.terros.com/docs/info/cli'
const MCP_DOCS_URL = 'https://docs.terros.com/docs/info/mcp'

function CliAccess(): ReactElement {
  const { t } = useTranslation()
  return (
    <Page>
      <Page.Heading title={t('Use the Terros CLI and AI assistants')} />
      <Page.Content>
        <Stack gap='lg' maw={720} align='flex-start'>
          <Text>
            {t(
              'The Terros CLI and AI assistants connect to Terros with your normal sign-in. They can see and do only what your Terros role allows. Every user can use them; there is nothing to turn on here.'
            )}
          </Text>
          <TButton component='a' href={CLI_DOCS_URL} target='_blank' icon='open_in_new' variant='secondary'>
            {t('Install the Terros CLI')}
          </TButton>
          <TButton component='a' href={MCP_DOCS_URL} target='_blank' icon='open_in_new' variant='secondary'>
            {t('Connect an AI assistant')}
          </TButton>
        </Stack>
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/integration/cli')({
  component: CliAccess,
})
